<template>
  <div class="course-cost-container">
    <el-button
      class="mwow-button-filled primary export-button"
      @click="handleExport"
      v-debounce="5000"
    >
      导出
    </el-button>
    <el-form size="mini" :model="searchInfo" inline>
      <el-form-item label="年份：">
        <el-date-picker
          v-model="searchInfo.year"
          type="year"
          placeholder="选择年"
          value-format="yyyy-MM-dd"
          @change="handleSearch"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <el-table
      size="mini"
      :data="tableData"
      v-horizontal-scroll
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      class="mwow-table"
    >
      <el-table-column label="月份" prop="month"></el-table-column>
      <el-table-column
        label="在读学员数"
        prop="total_student_count"
      ></el-table-column>
      <el-table-column
        label="耗[0]课次人数"
        prop="zero_student_count"
        width="100"
      >
        <template slot-scope="scope">
          <span
            class="mwow-green"
            style="cursor: pointer"
            @click="toActivation([0, 0], scope.row)"
            >{{ scope.row.zero_student_count }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="耗[0]课次占比"
        prop="zero_rate"
        width="100"
      ></el-table-column>
      <el-table-column
        label="耗[1]课次人数"
        prop="one_student_count"
        width="100"
      >
        <template slot-scope="scope">
          <span
            class="mwow-green"
            style="cursor: pointer"
            @click="toActivation([1, 1], scope.row)"
            >{{ scope.row.one_student_count }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="耗[1]课次占比"
        prop="one_rate"
        width="100"
      ></el-table-column>
      <el-table-column
        label="耗[2]课次人数"
        prop="two_student_count"
        width="100"
      >
        <template slot-scope="scope">
          <span
            class="mwow-green"
            style="cursor: pointer"
            @click="toActivation([2, 2], scope.row)"
            >{{ scope.row.two_student_count }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="耗[2]课次占比"
        prop="two_rate"
        width="100"
      ></el-table-column>
      <el-table-column
        label="耗[3]课次人数"
        prop="three_student_count"
        width="100"
      >
        <template slot-scope="scope">
          <span
            class="mwow-green"
            style="cursor: pointer"
            @click="toActivation([3, 3], scope.row)"
            >{{ scope.row.three_student_count }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="耗[3]课次占比"
        prop="three_rate"
        width="100"
      ></el-table-column>
      <el-table-column
        label="耗[4]课次人数"
        prop="four_student_count"
        width="100"
      >
        <template slot-scope="scope">
          <span
            class="mwow-green"
            style="cursor: pointer"
            @click="toActivation([4, 4], scope.row)"
            >{{ scope.row.four_student_count }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="耗[4]课次占比"
        prop="four_rate"
        width="100"
      ></el-table-column>
      <el-table-column
        label="耗[大于4]课次人数"
        prop="gt_four_student_count"
        width="120"
      >
        <template slot-scope="scope">
          <span
            class="mwow-green"
            style="cursor: pointer"
            @click="toActivation([5], scope.row)"
            >{{ scope.row.gt_four_student_count }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="耗[大于4]课次占比"
        prop="gt_four_rate"
        width="120"
      ></el-table-column>
    </el-table>
  </div>
</template>
<script>
import json2csv from "json2csv";
import eventBus from "@/utils/bus";
import { dateFormat } from "@/utils/timeFormat";
import { getConsumeCountRateApi } from "@/api/studyDetails";
export default {
  data() {
    return {
      searchInfo: {
        year: new Date().getFullYear() + "-01-01",
      },
      currentTimeRange: [],
      tableData: [],
    };
  },
  created() {
    eventBus.$on("student-statistics-show-course-cost", () => {
      this.handleSearch();
    });
  },
  methods: {
    handleSearch() {
      this.getList();
    },
    getList() {
      let params = {};
      if (this.searchInfo.year) {
        let target = this.searchInfo.year.slice(0, 4);
        let nowYear = String(new Date().getFullYear());
        params.start_date = target + "-01-01";
        if (nowYear === target) {
          // 当前年份
          params.end_date = dateFormat("YYYY-mm-dd", new Date());
        } else {
          params.end_date = target + "-12-31";
        }
      } else {
        return false;
      }
      this.currentTimeRange = [params.start_date, params.end_date];
      getConsumeCountRateApi(params).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((item) => {
            item.month_format = item.month.replace(/-/g, "年") + "月";
            item.zero_rate = item.zero.rate + "%";
            item.zero_student_count = item.zero.student_count;
            item.one_rate = item.one.rate + "%";
            item.one_student_count = item.one.student_count;
            item.two_rate = item.two.rate + "%";
            item.two_student_count = item.two.student_count;
            item.three_rate = item.three.rate + "%";
            item.three_student_count = item.three.student_count;
            item.four_rate = item.four.rate + "%";
            item.four_student_count = item.four.student_count;
            item.gt_four_rate = item.gt_four.rate + "%";
            item.gt_four_student_count = item.gt_four.student_count;
          });
          this.tableData = res.data.list.reverse();
        }
      });
    },
    handleExport() {
      try {
        let kv = {
          month_format: "月份",
          total_student_count: "在读学员数",
          zero_student_count: "耗[0]课次人数",
          zero_rate: "耗[0]课次占比",
          one_student_count: "耗[1]课次人数",
          one_rate: "耗[1]课次占比",
          two_student_count: "耗[2]课次人数",
          two_rate: "耗[2]课次占比",
          three_student_count: "耗[3]课次人数",
          three_rate: "耗[3]课次占比",
          four_student_count: "耗[4]课次人数",
          four_rate: "耗[4]课次占比",
          gt_four_student_count: "耗[大于4]课次人数",
          gt_four_rate: "耗[大于4]课次占比",
        };
        let fields = [
          "month_format",
          "total_student_count",
          "zero_student_count",
          "zero_rate",
          "one_student_count",
          "one_rate",
          "two_student_count",
          "two_rate",
          "three_student_count",
          "three_rate",
          "four_student_count",
          "four_rate",
          "gt_four_student_count",
          "gt_four_rate",
        ];
        const result = json2csv.parse([kv, ...this.tableData], {
          fields: fields,
          header: false,
        });
        //非IE浏览器
        const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
        //使用a标签的download属性实现下载功能
        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = `门店学员数据-耗课分布${this.currentTimeRange[0]}~${this.currentTimeRange[1]}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        this.$message({
          type: "error",
          message: err.toString(),
        });
      }
    },
    toActivation(cost, row) {
      eventBus.$emit("student-statistics-cost-navigate-to-activation", {
        cost,
        month: row.month,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.course-cost-container {
  .export-button {
    position: absolute;
    top: 12px;
    right: 20px;
    z-index: 100;
  }
}
</style>
